module.exports = __webpack_public_path__ + "img/con2.3bfe9d5d.jpg";